var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shopStoreTel" }, [
    _c("div", { staticClass: "shopStoreTel__main" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "shopStoreTel__mainTelWrap" }, [
        _c(
          "div",
          { staticClass: "shopStoreTel__mainTelWrapInner" },
          [
            _vm.twilioTel
              ? _c(
                  "tel-link",
                  {
                    staticClass: "shopStoreTel__num",
                    attrs: { value: _vm.twilioTel },
                  },
                  [
                    _c("i", { staticClass: "phone icon spOnly" }),
                    _vm._v(_vm._s(_vm.twilioTel) + "\n        "),
                  ]
                )
              : _c(
                  "tel-link",
                  {
                    staticClass: "shopStoreTel__num",
                    attrs: { value: _vm.conciergeTel },
                  },
                  [
                    _c("i", { staticClass: "phone icon spOnly" }),
                    _vm._v(_vm._s(_vm.conciergeTel) + "\n        "),
                  ]
                ),
            _vm._v(" "),
            _c("p", [
              _vm._v("※こちらは20名以上～大人数のご宴会専用ダイヤルです"),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shopStoreTel__sub" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "shopStoreTel__subLinkWrap" },
        [_c("tel-link", { attrs: { value: _vm.shopTel } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shopStoreTel__mainTitleWrap" }, [
      _c("h4", { staticClass: "shopStoreTel__mainTitle" }, [
        _c("span", [_vm._v("20")]),
        _c("span", [_vm._v("名以上")]),
        _c("span", [_vm._v("の宴会")]),
        _c("br", { staticClass: "pcOnly" }),
        _vm._v("のご相談はこちらへ！"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shopStoreTel__subTextWrap" }, [
      _c("p", [
        _c("span", [
          _vm._v("20名未満、人数変更・その他の"),
          _c("br", { staticClass: "pcOnly" }),
          _vm._v("お問い合わせ"),
        ]),
        _vm._v("はこちら"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }